import { memo, useRef, useState } from 'react';
import { useOnClickOutside } from "../../../../../helpers";
import StyledDropdown from "../../../../StyledComponents/StyledDropdown";
import { StyledButton } from "../../../../StyledComponents";
import styles from '../../styles.module.scss';
import { usePolyglot } from "../../../../../context/Polyglot";
import { MemberOption } from "../../../../../pages/chat/ChatSettings/ChatSettingsMenu/children/GroupMember";
import { ChatMemberFull } from '../../../../../redux/slices/chatNSlice';
import EntityIcon from '../../../../icons/EntityIcon';
import { useChatChatter } from '../../../../../redux/services/nebulaChat';
import { useTypedSelector } from '../../../../../redux/hooks';
import { selectCanAdminAllPublicGroups, selectCurrentUserId } from '../../../../../redux/slices';

interface Props {
    member: ChatMemberFull;
    onRemove: () => void;
}

const GroupEditMember = memo<Props>(({ member, onRemove }) => {
    const [kickWarning, setKickWarning] = useState<boolean>(false);

    const userUuid = useTypedSelector(selectCurrentUserId);
    const canAdminPublicGroups = useTypedSelector(selectCanAdminAllPublicGroups);

    const chatter = useChatChatter({ userUuid: member.member });

    const { t } = usePolyglot();

    const settingsRef = useRef<HTMLDivElement>(null);

    useOnClickOutside(settingsRef, () => setKickWarning(false))

    const options: MemberOption[] = [
        {
            label: kickWarning ? t("phrases.are_you_sure") : t("actions.remove_from_group"),
            value: 'remove',
            onClick: onRemove
        }
    ]

    return (
        <div
            className={styles.group_member}
            onBlur={(e) => {
                if (e.relatedTarget && !e.currentTarget.contains(e.relatedTarget)) {
                    setKickWarning(false)
                }
            }}
        >
            <div className={styles.group_member_icon}>
                <EntityIcon type='user' details={{
                    uuid: chatter.uuid,
                    avatar_key: chatter.file_key,
                    display_name: chatter.name
                }}
                    size={32}
                />
            </div>
            <p>
                {chatter.name}
            </p>
            <div
                className={styles.group_member_option}
                ref={settingsRef}
            >
                {(canAdminPublicGroups && !member.is_creator) && member.member !== userUuid ? (
                    <StyledDropdown
                        options={options}
                        component={(props) =>
                            <StyledButton
                                key={`GCMO_${props.value}`}
                                buttonStyle='text'
                                onClick={() => props.onClick()}
                                context={props.value === 'remove' ? 'danger' : undefined}
                            >
                                <p>
                                    {props.label}
                                </p>
                            </StyledButton>
                        }
                        placeHolder={(member.is_creator && `${t("terms.creator", 1)}`) || (member.is_admin && `${t("terms.admin", 1)}`) || 'Member'}
                        direction='right'
                    />
                ) : (
                    <p>
                        {(member.is_creator && `${t("terms.creator", 1)}`) || (member.is_admin && `${t("terms.admin", 1)}`) || 'Member'}
                    </p>
                )}
            </div>
        </div>
    );
});

export default GroupEditMember;
